import React from 'react';
import FormInputTagsItem from './FormInputTagsItem';
import VehicleSearch from '../../search/VehicleSaleSearch';

export default (props) => {
  return <FormInputTagsItem {...props} inputComponent={VehicleSearch} />;
};